import { h } from 'preact'; /** @jsx h */

export const Price = ({payMode, month, year}) => (
    <p className="btn-cta">
        <b className="big-text">{
            payMode === "year" ? year : month
        }</b>
        <div>
        <div className="medium-text">USD/month</div>
            {
                payMode === "year" && <div className="small-text">Paid annually</div>
            }
        </div>
    </p>
);